const axios = require("axios");

export async function emailService(formData) {
  return await axios.post(process.env.REACT_APP_CLIENT_API_ENDPOINT + "/utils/email", formData, {
    headers: {
      "x-api-key": process.env.REACT_APP_API_KEY
    }
  });
}
